export default __webpack_public_path__ + "static/impact2-415cefc4cbeee350ef9175a448e5333a.png";